import React, { FC, useEffect, useRef } from 'react';
import styles from './page_nav_scroll_handler.module.scss';

export const PageNavScrollHandler: FC = ({ children }) => {
  const navRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onScroll = () => {
      const container = window.document.querySelector(
        `[data-reference=page]`,
      ) as HTMLElement;
      const containerHeight = container.offsetHeight;
      const nav = navRef.current;
      if (nav) {
        const navHeight = nav.offsetHeight;
        const bottomMargin = 15;
        const topPadding = 10;
        if (
          window.pageYOffset >
          containerHeight + bottomMargin - navHeight - topPadding
        ) {
          nav.classList.add(styles.bottom);
          nav.classList.remove(styles.container);
        } else {
          nav.classList.add(styles.container);
          nav.classList.remove(styles.bottom);
        }
      }
    };

    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <div className={styles.container} ref={navRef}>
      {children}
    </div>
  );
};
